export default "__VITE_ASSET__DPUzRfc8__"